import {Directive, TemplateRef} from "@angular/core";

/**
 * Структурная директива для переопределения шаблона футера страницы.
 * @publicApi
 */
@Directive({selector: '[dxPageFooter]'})
export class DxPageFooterDirective {
  constructor(public template: TemplateRef<any>) { }
}
